'use strict';
require('../flow/index')(require('../apps/fees/RootComponent.react'));



// WEBPACK FOOTER //
// ./public/js/bootstrap/fees.js